import { render } from "./AutoConfig.vue?vue&type=template&id=32ac7042&scoped=true&ts=true"
import script from "./AutoConfig.ts?vue&type=script&lang=ts&external"
export * from "./AutoConfig.ts?vue&type=script&lang=ts&external"

import "./AutoConfig.scss?vue&type=style&index=0&id=32ac7042&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ac7042"]])

export default __exports__